<template>
  <div class="tela-cargas">
    <Loading :isActive="loading"></Loading>

    <div class="table-responsive">
      <table class="table table-hover tabela-utilitarios">
        <thead>
        <tr>
          <th>Utilitário</th>
          <th class="text-right">Ação</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <div class="util-cel">
              <span class="util-icone">
                <fa-icon icon="sync" />
              </span>
              <span class="util-texto">
                <span class="util-nome">Limpar cache</span>
                <small>Limpa o cache da aplicação</small>
              </span>
            </div>
          </td>
          <td class="actions text-right">
            <div class="acoes-cel">
              <CButton color="success" size="sm" v-on:click="cacheConfirm()" title="Executar">
                <fa-icon icon="play" />
              </CButton>
              <LogAlteracaoDados tabela="utilitario" chave="clear-cache">
                <template #trigger="{ open }">
                  <CButton
                      color="secondary"
                      variant="outline"
                      size="sm"
                      class="btn-acao-log"
                      title="Log de alterações"
                      @click="open"
                  >
                    <fa-icon icon="clipboard-list" />
                  </CButton>
                </template>
              </LogAlteracaoDados>
            </div>
          </td>
        </tr>
        <tr class="linha-perigo">
          <td>
            <div class="util-cel">
              <span class="util-icone util-icone--perigo">
                <fa-icon icon="users" />
              </span>
              <span class="util-texto">
                <span class="util-nome">Deslogar usuários</span>
                <small>Desloga todos os usuários, inclusive você</small>
              </span>
            </div>
          </td>
          <td class="actions text-right">
            <div class="acoes-cel">
              <CButton color="danger" size="sm" v-on:click="logoutConfirm()" title="Executar">
                <fa-icon icon="play" />
              </CButton>
              <LogAlteracaoDados tabela="utilitario" chave="logout">
                <template #trigger="{ open }">
                  <CButton
                      color="secondary"
                      variant="outline"
                      size="sm"
                      class="btn-acao-log"
                      title="Log de alterações"
                      @click="open"
                  >
                    <fa-icon icon="clipboard-list" />
                  </CButton>
                </template>
              </LogAlteracaoDados>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {post} from "@/helpers/apiRequest";
import LogAlteracaoDados from "@/components/Log/LogAlteracaoDados.vue";

export default {
  name: "utilitarios",
  components: {
    LogAlteracaoDados,
  },
  props: [],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    logoutConfirm() {
      this.$swal({
        title: "Confirma esta ação?",
        text: "Ao confirmar, todos usuários vão ser deslogados, inclusive você.",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
            if (res.value) {
              this.loading = true;
              post(`/admin/utilitarios/logout`)
                .then((json) => {
                  this.loading = false;
                  this.$swal({
                    title: "Sucesso!",
                    text: json.message,
                    icon: "success",
                    confirmButtonText: "Fechar",
                  })
                  .then((res) => {
                    if (res.value) {
                      this.logout();
                    }
                  })
                })
                .catch((err) => {
                  this.loading = false;
                  this.$swal({
                    title: "Falha!",
                    text: err.message,
                    icon: "error",
                  });
                });
            }
          }
        )
        .catch(() => {
        });
    },
    cacheConfirm() {
      this.$swal({
        title: "Confirma esta ação?",
        text: "Ao confirmar, o cache da aplicação será limpo.",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            post(`/admin/utilitarios/clear-cache`)
              .then((json) => {
                this.loading = false;
                this.$swal({
                  title: "Sucesso!",
                  text: json.message,
                  icon: "success",
                  confirmButtonText: "Fechar",
                })
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha!",
                  text: err.message,
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
    logout() {
      localStorage.clear()
      this.$router.push('/login')
    }
  },
};
</script>

<style scoped>
/* Tokens VersoTech (escopo da aba de Utilitários).
   Os blocos compartilhados entre as abas (btn-acao-log, text-right, actions)
   vivem no parcial src/assets/scss/_cargas.scss, sob a raiz .tela-cargas. */
.util-cel {
  display: flex;
  align-items: center;
  gap: 12px;
}

.util-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  color: var(--primary, #3a3e81);
  background: #eef0f8;
  border: 1px solid #dadef0;
  border-radius: 8px;
}

.util-icone--perigo {
  color: var(--verso-falha, #c0392b);
  background: #fdeaea;
  border-color: #f3cdc8;
}

.util-texto {
  display: flex;
  flex-direction: column;
}

.util-nome {
  font-weight: 700;
  color: #2c2e38;
}

.tabela-utilitarios small {
  display: block;
  color: var(--verso-neutro, #949aa8);
}

.linha-perigo {
  background: #fffafa;
}

.acoes-cel {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
